<div class="modal-content">
  <!-- Header -->
  <div class="modal-header company-modal-header">
    <span>Link to a Coaching Challenge</span>
    <i class="material-icons" data-bs-dismiss="modal" (click)='closeModal()'>close</i>
  </div>

  <div class="modal-body">
    @if (isPrivateChallenge) {
      <div class="form-group">
        <label class="text-bold">Note : A Private Challenge is currently linked.</label>
      </div>
    }

    <!-- Radio buttons to switch types -->
    <div class="form-group">
      <input type="radio" name="redirectType" [value]="isTypeBtn" [checked]="isTypeBtn" (click)="setBlockType(true)" />
      Button
      <input type="radio" name="redirectType" [value]="isTypeImg" [checked]="isTypeImg" (click)="setBlockType(false)"
        style="margin-left: 15px;" /> Image
      </div>
      <!-- Button text for button type -->
      @if (isTypeBtn) {
        <form>
          <div class="form-group">
            <div class="row align-items-center">
              <label class="control-label col-sm-4 text-start">Button Text</label>
              <div class="col-sm-8">
                <input type="text" [(ngModel)]="buttonText" name="btnText" class="form-control">
              </div>
            </div>
          </div>
        </form>
      }
      <!-- Image upload for image type -->
      @if (isTypeImg) {
        <div class="image-upload-box" id="editImageUploadComponentId">
          <div id="playbook-cover-container" style="text-align: center; padding: 0px;">
            <input value="" type="file" class="uploadResource btn" (change)="fileChangeEvent($event)" style="display: none;"
              id="file-in" />
            <label for="file-in">
              @if (uploadedImg?.id == null) {
                <div style="margin-top: 20px;" class="cursor-pointer">
                  <span class="material-icons upload-icon upload-icon-color">cloud_upload</span>
                  <p style="font-size: 14px; font-weight: bold; margin-top: 4px;">Click to upload JPG or PNG image</p>
                </div>
              }
              @if (uploadedImg?.id != null) {
                <img onerror="this.src = 'assets/img/loader.gif'" (load)="imageLoaded = true;" [hidden]="!imageLoaded"
            src="{{'/api/Assets/Image/' + uploadedImg?.id + '?height=300&ratio=' + devicePixelRatio | loadSecureAssets : true | async}}"
            class="container-preview-image" alt="" />
}
        </label>
      </div>
      @if (progressbarDisplay) {
<div class="progress progress-style">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="0"
          aria-valuemin="0" aria-valuemax="100" [style.width]="dynamicProgressbar + '%'">
                {{dynamicProgressbar}}%
              </div>
            </div>
          }
        </div>
      }
      <!-- Challenge section -->
      <label class="text-bold">Select Challenge</label>
      <div class="challenge-popup-wrapper">
        <div class="row" style="margin: 0px;">
          <!-- Challenge list -->
          <div class="col-lg-4 col-md-4 col-sm-12 col-12 challenge-side-list scrollbar scrollbar-inverse">
            <ul class="challenge-list__custom">
              @for (challenge of challenges; track challenge; let i = $index) {
                <li (click)="selectChallenge(challenge)"
                  [ngClass]="{'active': selectedChallenge && selectedChallenge.challengeId == challenge.challengeId}"
                  [ngStyle]="{'border-top': '3px solid ' + challenge.hexCode}"
                  >
                  <span>{{challenge.title}}</span>
                  <div class="challenge-icon-sm" [ngStyle]="{'color':challenge.hexCode}"
                    style="justify-content: space-between;" [style.display]="challenge.status == 0 ? 'flex' : 'block'">
                    @if (challenge.status == 0) {
                      <p style="margin: 4px 0px;">Draft</p>
                    }
                    <strong> <i class="material-icons">query_builder</i>{{challenge.endDate | date: 'MM/dd'}}</strong>
                  </div>
                </li>
              }
            </ul>
          </div>
          <!-- Challenge details -->
          @if (selectedChallenge) {
            <div class="col-lg-8 col-md-8 col-sm-12 col-12">
              <div class="col-md-12 pe-0">
                @if (selectedChallenge && selectedChallenge.title) {
                  <label class="text-bold">
                    Details for {{selectedChallenge.title}}
                  </label>
                }
                @for (challenge of selectedChallenge.challengeChecklists; track challenge) {
                  <div class="challenge-details-inner challenge-inner-custom pe-0"
                    >
                    <div class="pl-30">
                      <i class="material-icons">format_list_bulleted</i> {{challenge.title}}
                    </div>
                    <div>
                      <ul>
                        @for (task of challenge.challengeTasks; track task) {
                          <li> {{task.title}} </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <!-- Loader and note -->
          @if (!selectedChallenge) {
            <div style="text-align: center;">
              <label class="text-bold">Please select challenge.</label>
              <br>
                @if (!isLoaded) {
                  <img src="../../../../../assets/img/loader1.gif" alt="">
                }
                <br>
                  @if (!isLoaded) {
                    <span>Loading...</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" (click)="closeModal()">Cancel</button>
          <button type="button" class="btn btn__btn-default btn__orange" [disabled]="disabilityCheck()"
          (click)="saveChallenge()">Save</button>
        </div>
      </div>